module.exports = __webpack_public_path__ + "static/media/client_projects.017539b3.svg";